import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Button, CircularProgress, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography, TableCell } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { IBooking, IBookingVehicleGroup, IVehiclePriceGroup, IBookingSchedule, IInvoice, BookingStatus, ISwapRequestCreateInput, ISwapRequest, SwapRequestStatus, InvoiceStatus, BookingType } from '../../../../reducers/bookings/types';
import { StyledTableCell, StyledTableRow } from '../../../StyledTable';
import { DateTimeFormat, DATE_TYPE, formatGraphQLErrorMessage, toCurrency } from '../../../utils';
import { getSignedUrl } from '../../../../utils/getSignedUrl';
import { DateTime as d, Settings } from "luxon";
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useHistory } from 'react-router-dom';
import { InvoiceType } from '../../NewBooking/Invoices/utils';
import { IBranch } from "../../../../reducers/website/types";
import GenerateSwapRequestDialog from "./GenerateSwapRequestDialog";
import { useMutation } from "@apollo/client";
import { CREATE_SUBSCRIPTION_SWAP_REQUEST } from "../../../../graphql/bookings/createSubscriptionVehicleSwapMutation";
import { useSnackBar } from "../../../SnackBarContext/SnackBarContext";
import { SnackBarVariant } from "../../../SnackbarWrapper/SnackbarWrapper";
import { ApolloError } from "apollo-boost";
import { UPDATE_SUBSCRIPTION_SWAP_REQUEST } from "../../../../graphql/bookings/updatesubscriptionSwapRequest";
import { getLocalizedBookingSyntex, getLocalizedDateFormat } from "../../../../utils/localized.syntex";
import { CANCEL_CONSUMER_SWAP_REQUEST } from "../../../../graphql/bookings/consumerCancelSwapRequestMutation";
import { BookingStatusText, isNoShowCancellation } from "../../utils";
import { CustomerType } from "../../../../reducers/auth/types";
import { DriversInformation } from "../Drivers/DriversInformation";
import { bookingCategories } from "../../NewBooking/utils";
import { BOOKING_STATUS, UserJobStatus } from "../../Summary/const";
import MapSection from "../../../Tracking/MapSection";
import { useTranslation } from "react-i18next";
import { PaymentGatewayLabels, PaymentStatus } from "../../../../reducers/bookings/types";
export interface IProps {
  booking: IBooking
}

const BookingSummary: React.FC<IProps> = (props) => {
  const history = useHistory()
  const snackbar = useSnackBar();
  const [booking, setBooking] = useState<IBooking>();
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const { currency, locale } = website.organisation;
  const { country } = website.organisation.address;
  const user = useSelector((state: IAppState) => state.authReducer.user);
  const [logoUrl, setLogoUrl] = useState<any>("");
  const branchData = website.branches;
  const [currentBranch, setCurrentBranch] = useState<IBranch>();
  const [openSwapRequestDialog, setOpenSwapRequestDialog] = useState<boolean>(false);
  const [selectedRequestToUpdate, setSelectedRequestToUpdate] = useState<ISwapRequest>();
  const [showDeposit, setShowDeposit] = useState<boolean>(true);
  const [showPaymentAndInvoice, setShowPaymentAndInvoice] = useState<boolean>(true);
  const hasValidProtectionPlan = booking?.protectionPlan?.plan?.name?.trim() !== "";
  const isContractHire = website.organisation.bookingCategories.some((category) => category.isContractHire === true)
  const { t } = useTranslation();
  const isSupplierPortalEnabled = website.organisation?.supplierPortalEnabled
  const locationTrackingEnabled = isSupplierPortalEnabled || false




  function getTaskDetails() {

    if (!locationTrackingEnabled) {
      return;
    }
    try {


      for (const job of booking?.currentBookingSchedules[0]?.linkedActions || []) {
        if (job.jobLinked && job.jobLinked.id && job.jobLinked.status) {

          if (job.jobLinked.status === UserJobStatus.IN_PROGRESS) {
            return {
              jobId: job.jobLinked.id,
              jobStatus: job.jobLinked.status,
              jobCategory: job.jobLinked.subCategory,
              lastKnownDriverLocation: job.jobLinked?.lastKnownDriverLocation,
              customerLocation: job.jobLinked.address?.dropOffAddress?.geometry
            }
          }

        }
      }

    }

    catch (err: any) {
      snackbar({
        message: err?.message,
        variant: SnackBarVariant.ERROR
      });
    }

  }


  function shouldShowTrackingModal() {
    try {


      let flag = true

      // TODO this should be removed and enabled for internal drivers when ready
      if (!locationTrackingEnabled) {
        flag = false
        return flag
      }

      const res = getTaskDetails()

      if (!res?.jobId) {
        flag = false
      }

      if (res?.jobStatus !== UserJobStatus.IN_PROGRESS) {
        flag = false
      }

      if (booking?.status === BOOKING_STATUS.CANCELLED || booking?.status === BOOKING_STATUS.DECLINED || booking?.status === BOOKING_STATUS.COMPLETED) {
        flag = false
      }

      return flag
    } catch (err: any) {
      snackbar({
        message: err?.message,
        variant: SnackBarVariant.ERROR
      });
    }
  }

  const [createSubscriptionVehicleSwapRequest, { data: bookingSubscriptionSwapData, loading: loadingCreateSwapRequest }] = useMutation(
    CREATE_SUBSCRIPTION_SWAP_REQUEST,
    {
      onCompleted: (data) => {
        if (data && data.consumerCreateSwapRequest) {
          setBooking(data.consumerCreateSwapRequest)
          snackbar({
            message: "Swap request created successfully",
            variant: SnackBarVariant.SUCCESS
          });
        }
        setOpenSwapRequestDialog(false)
      },
      onError: (error: ApolloError) => {
        snackbar({
          message: formatGraphQLErrorMessage(error.message),
          variant: SnackBarVariant.ERROR
        });
      }
    }
  );

  const [updateSubscriptionVehicleSwapRequest, { data: updateBookingSubscriptionSwapData, loading: loadingUpdateBookingSwapData }] = useMutation(
    UPDATE_SUBSCRIPTION_SWAP_REQUEST,
    {
      onCompleted: (data) => {
        if (data && data.consumerUpdateSwapRequest) {
          setBooking(data.consumerUpdateSwapRequest)
          snackbar({
            message: "Swap request updated successfully",
            variant: SnackBarVariant.SUCCESS
          });
        }
        setOpenSwapRequestDialog(false)
      },
      onError: (error: ApolloError) => {
        snackbar({
          message: formatGraphQLErrorMessage(error.message),
          variant: SnackBarVariant.ERROR
        });
      }
    }
  );

  const [cancelSwapRequest, { data: cancelSwapRequestData, loading: loadingCancelSwap }] = useMutation(
    CANCEL_CONSUMER_SWAP_REQUEST,
    {
      onCompleted: (data) => {
        if (data && data.consumerCancelSwapRequest) {
          setBooking(data.consumerCancelSwapRequest)
          snackbar({
            message: "Swap request cancelled successfully",
            variant: SnackBarVariant.SUCCESS
          });
        }
        setOpenSwapRequestDialog(false)
      },
      onError: (error: ApolloError) => {
        snackbar({
          message: formatGraphQLErrorMessage(error.message),
          variant: SnackBarVariant.ERROR
        });
      }
    }
  );

  useEffect(() => {
    if (props.booking) {
      const _bookingData: IBooking = props.booking;
      if (_bookingData.bookingCategory && !bookingCategories[_bookingData.bookingCategory]?.showDepositDetails) {
        setShowDeposit(false);
        setShowPaymentAndInvoice(false);
      }
      setBooking(_bookingData);

      const selectedBranch = branchData.find(
        (branch) => branch.id === _bookingData.branchId
      );
      setCurrentBranch(selectedBranch);
      if (selectedBranch) {
        Settings.defaultZone = selectedBranch.timeZone || "Europe/London";
      }
    }
    return () => {
      Settings.defaultZone = "Europe/London"
    }
  }, [props.booking]);

  useEffect(() => {
    const getLogoUpload = async () => {
      if (!website.organisation) {
        return;
      }
      const file = await getSignedUrl(website.organisation.logoUrl)
      setLogoUrl(file);
    };
    if (website.organisation && website.organisation.logoUrl) {
      getLogoUpload();
    }
    if (website.organisation.closeGroupSharingEnabled) {
      setShowDeposit(false);
    }
  }, [website.organisation]);

  if (!booking) {
    return <CircularProgress size={20} thickness={5} />
  }

  const isBusinessCustomerBooking =
    booking.customerType === "business" &&
      booking.businessCustomer &&
      booking.businessCustomer.id !== ""
      ? true
      : false;

  const getMileageLimitText = (
    mileageLimit: number,
    rateType: string,
  ) => {
    const distanceUnit = currentBranch?.distanceUnit || "mile";
    switch (rateType) {
      case "hourly":
        return `${mileageLimit} ${distanceUnit}s per hour`;
      case "daily":
        return `${mileageLimit} ${distanceUnit}s per day`;
      case "weekly":
        return `${mileageLimit} ${distanceUnit}s per week`;
      case "monthly":
        return `${mileageLimit} ${distanceUnit}s per month`;
    }
  };

  const onCreateSwapRequest = (data: ISwapRequestCreateInput) => {
    if (data && data.dateForSwap) {
      if (data.id) {
        updateSubscriptionVehicleSwapRequest({
          variables: {
            data: {
              dateForSwap: data.dateForSwap,
              notes: data.notes,
              bookingId: booking.id,
              swapRequestId: data.id,
              vehicleAllocated: data.vehicleAllocated
            }
          }
        })
      } else {
        createSubscriptionVehicleSwapRequest({
          variables: {
            data: {
              dateForSwap: data.dateForSwap,
              notes: data.notes,
              bookingId: booking.id,
              vehicle: booking.activeSubscription.vehicle.id,
              vehicleAllocated: data.vehicleAllocated
            }
          }
        })
      }
    }
  }

  const getDepositPayments = () => {
    if (!booking?.depositDetails) return [];
    return booking.depositDetails.payments?.length
      ? booking.depositDetails.payments
      : (booking.depositDetails.payment ? [booking.depositDetails.payment] : []);
  };

  const getAdjustedCreditNotes = () => {
    if (!booking?.depositDetails) return [];
    return booking.depositDetails.adjustedCreditNotes?.length
      ? booking.depositDetails.adjustedCreditNotes
      : [];
  };

  const onCancelSwapRequest = (swapRequestId: string) => {
    if (booking) {
      cancelSwapRequest({
        variables: {
          data: {
            bookingId: booking.id,
            swapRequestId
          }
        }
      })
    }
  }
  const hideVehicleDetails = [BookingStatus.REQUIRES_APPROVAL, BookingStatus.CONFIRMED].includes(booking.status);

  const renderVehicleDetails = () => {
    if (booking) {
      if (booking.isSubscription) {
        const vehicleSchedule = booking.currentBookingSchedules[0]
        const driver = booking.businessCustomer?.approvedDrivers.find((driver => driver.id === vehicleSchedule?.driver?.id));
        return (
          <>
            {
              booking.isSubscription && booking.previousBookingSchedules?.length > 0 && (
                <Grid item xs={12} style={{ marginTop: 10 }}>
                  <div className={`${styles.box}`}>
                    <div className="font-medium semi-bold margin-bottom padding-bottom">{t("root:previousVehicleDetails")}</div>
                    <div style={{ margin: "0 -10px -10px -10px" }}>
                      {
                        booking.isSubscription &&
                        booking.previousBookingSchedules &&
                        booking.previousBookingSchedules.length > 0 && (
                          <>
                            <TableContainer style={{ maxHeight: "100%", }} className={`${booking.businessCustomer ? "row-hover" : ""}`}>
                              <Table stickyHeader aria-label="customized table">
                                <TableHead>
                                  <StyledTableRow>
                                    <StyledTableCell
                                      align="left"
                                    >
                                      <Typography>{`${isContractHire ? t('root:contractHire') : t('root:subscription')}`}</Typography>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align="left"
                                    >
                                      <Typography>{t("root:registration")}</Typography>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align="left"
                                    >
                                      <Typography>{t("root:makeModel")}</Typography>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align="left"
                                    >
                                      <Typography>{t("root:vin")}</Typography>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      align="left"
                                    >
                                      <Typography>{t("root:mileageLimit")}</Typography>
                                    </StyledTableCell>
                                    {
                                      booking.customerType === CustomerType.BUSINESS && (
                                        <StyledTableCell align="left">
                                          <Typography>{t("root:driverAssigned")}</Typography>
                                        </StyledTableCell>
                                      )
                                    }
                                  </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                  {
                                    booking.previousBookingSchedules.map(vSchedule => {
                                      return (
                                        <>
                                          <TableRow>
                                            <StyledTableCell>{booking?.activeSubscription?.subscription?.name}</StyledTableCell>
                                            <StyledTableCell>{vSchedule.vehicle?.licencePlate}</StyledTableCell>
                                            <StyledTableCell>{vSchedule.vehicle?.make} {vSchedule.vehicle?.model}</StyledTableCell>
                                            <StyledTableCell>{vSchedule.vehicle?.vin}</StyledTableCell>
                                            <StyledTableCell>{booking?.activeSubscription?.unlimitedMileage ? t("root:unlimited") : booking?.activeSubscription?.mileageLimit}</StyledTableCell>
                                            {
                                              booking.customerType === CustomerType.BUSINESS && (
                                                <StyledTableCell>
                                                  {driver ? `${driver.firstName} ${driver.lastName}` : t("root:na")}
                                                </StyledTableCell>
                                              )
                                            }
                                          </TableRow>
                                        </>
                                      )
                                    })
                                  }
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </>
                        )
                      }
                    </div>
                  </div>
                </Grid>
              )
            }
            <Grid item xs={12} style={{ marginTop: 10 }}>
              <div className={`${styles.box}`}>
                <div className="font-medium semi-bold margin-bottom padding-bottom">{t("root:currentVehicleDetails")}</div>
                <div style={{ margin: "0 -10px -10px -10px" }}>
                  <TableContainer style={{ maxHeight: "100%", }} className={`${booking.businessCustomer ? "row-hover" : ""}`}>
                    <Table stickyHeader aria-label="customized table">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell>{`${isContractHire ? t('root:contractHire') : 'Subscription'}`}</StyledTableCell>
                          <StyledTableCell>{t("root:makeModel")}</StyledTableCell>
                          {
                            [BookingStatus.IN_PROGRESS, BookingStatus.COMPLETED].includes(booking.status) && (
                              <StyledTableCell>{t("root:registration")}</StyledTableCell>
                            )
                          }
                          <StyledTableCell>{t("root:vin")}</StyledTableCell>
                          {
                            booking.customerType === "business" && (
                              <StyledTableCell align="left">
                                <Typography>{t("root:driverAssigned")}</Typography>
                              </StyledTableCell>
                            )
                          }
                          <StyledTableCell>{t("root:mileageLimit")}</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {
                          booking.activeSubscription && (
                            <StyledTableRow >
                              <StyledTableCell>{booking?.activeSubscription?.subscription?.name}</StyledTableCell>
                              <StyledTableCell>{`${booking?.activeSubscription?.vehicle?.make} ${booking?.activeSubscription?.vehicle?.model}`}</StyledTableCell>
                              {
                                ([BookingStatus.IN_PROGRESS, BookingStatus.COMPLETED].includes(booking.status)) && (
                                  <StyledTableCell>{booking?.activeSubscription?.vehicle?.licencePlate}</StyledTableCell>
                                )
                              }
                              <StyledTableCell>{booking?.activeSubscription?.vehicle.vin}</StyledTableCell>
                              {
                                booking.customerType === "business" && (
                                  <StyledTableCell>
                                    {driver ? `${driver.firstName} ${driver.lastName}` : t("root:na")}
                                  </StyledTableCell>
                                )

                              }
                              <StyledTableCell>{booking?.activeSubscription?.unlimitedMileage ? t("root:unlimited") : booking?.activeSubscription?.mileageLimit}</StyledTableCell>
                            </StyledTableRow>
                          )
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </Grid>
          </>
        )
      }
      else {
        return (
          <Grid item xs={12} style={{ marginTop: 10 }}>
            <div className={`${styles.box}`}>
              <div className="font-medium semi-bold margin-bottom padding-bottom">{t("root:currentVehicleDetails")}</div>
              <div style={{ margin: "0 -10px -10px -10px" }}>

                <TableContainer style={{ maxHeight: "100%", }} className={`${booking.businessCustomer ? "row-hover" : ""}`}>
                  <Table stickyHeader aria-label="customized table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>{t("root:priceGroup")}</StyledTableCell>
                        {!hideVehicleDetails && <>
                          <StyledTableCell>{t("root:makeModel")}</StyledTableCell>
                          {[BookingStatus.IN_PROGRESS, BookingStatus.COMPLETED].includes(booking.status) && (
                            <StyledTableCell>{t("root:registration")}</StyledTableCell>)}
                          <StyledTableCell>{t("root:vin")}</StyledTableCell>
                          {
                            booking.customerType === "business" && (
                              <StyledTableCell align="left">
                                <Typography>{t("root:driverAssigned")}</Typography>
                              </StyledTableCell>
                            )
                          }
                        </>
                        }
                        {
                          !website.organisation.closeGroupSharingEnabled && (
                            <StyledTableCell>{t("root:mileageLimit")}</StyledTableCell>
                          )
                        }

                        {hideVehicleDetails && <StyledTableCell>{t("root:quantity")}</StyledTableCell>}
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {booking?.vehicleGroups?.map(
                        (vehicleGroup: IBookingVehicleGroup, idx: number) => {
                          const vg = vehicleGroup.vehicleGroup as IVehiclePriceGroup;
                          const basePrice = vg.basePrices.find(bp => bp.rateTypeName === booking.rateTypeName);

                          return (
                            !hideVehicleDetails ? <React.Fragment key={idx}>
                              {vehicleGroup?.activeVehicleSchedules?.map(
                                (vehicleSchedule: IBookingSchedule, index: number) => {
                                  const { vehicle, id, vehicleStatus } = vehicleSchedule;
                                  const driver = user?.businesscustomers?.approvedDrivers.find((driver => driver?.id === vehicleSchedule.driver?.id));
                                  const searchParams = new URLSearchParams();
                                  searchParams.set("booking", props.booking.id || "");
                                  return (
                                    <React.Fragment key={index}>
                                      <StyledTableRow onClick={() => booking.businessCustomer && !vehicle.isGhostVehicle && history.push(`/account/vehicles/${vehicle.id}?${searchParams.toString()}`)}>
                                        {index === 0 && (
                                          <StyledTableCell rowSpan={vehicleGroup.activeVehicleSchedules?.length}>
                                            {vehicleGroup.name ? vehicleGroup.name : vg.name}
                                          </StyledTableCell>
                                        )}
                                        <StyledTableCell>{`${vehicle?.make} ${vehicle.model}`}</StyledTableCell>
                                        {[BookingStatus.IN_PROGRESS, BookingStatus.COMPLETED].includes(booking.status) && (
                                          <StyledTableCell>
                                            <span>{vehicle.isGhostVehicle ? t("root:toBeAssigned") : vehicle?.licencePlate.toUpperCase()}</span>
                                          </StyledTableCell>
                                        )}
                                        <StyledTableCell>
                                          {vehicle.vin || t("root:na")}
                                        </StyledTableCell>
                                        {
                                          booking.customerType === "business" && (
                                            <StyledTableCell>
                                              {driver ? `${driver.firstName} ${driver.lastName}` : t("root:na")}
                                            </StyledTableCell>
                                          )
                                        }
                                        {!website.organisation.closeGroupSharingEnabled && (
                                          vehicleGroup && vehicleGroup.mileageLimit && basePrice ? (
                                            <StyledTableCell>
                                              {getMileageLimitText(vehicleGroup.mileageLimit, basePrice.rateTypeName)}
                                            </StyledTableCell>
                                          ) : vehicleGroup?.unlimitedMileage ? (
                                            <StyledTableCell>{t("root:unlimitedMileage")}</StyledTableCell>
                                          ) : (
                                            <StyledTableCell>{t("root:na")}</StyledTableCell>
                                          )
                                        )}
                                      </StyledTableRow>
                                    </React.Fragment>
                                  );
                                }
                              )}
                            </React.Fragment> :
                              <StyledTableRow>
                                <StyledTableCell>
                                  {vehicleGroup.name ? vehicleGroup.name : vg.name}
                                </StyledTableCell>

                                {!website.organisation.closeGroupSharingEnabled && (
                                  vehicleGroup && vehicleGroup.mileageLimit && basePrice ? (
                                    <StyledTableCell>
                                      {getMileageLimitText(
                                        vehicleGroup.mileageLimit,
                                        basePrice.rateTypeName
                                      )}
                                    </StyledTableCell>
                                  ) : vehicleGroup?.unlimitedMileage ? (
                                    <StyledTableCell>{t("root:unlimitedMileage")}</StyledTableCell>
                                  ) : (
                                    <StyledTableCell>{t("root:na")}</StyledTableCell>
                                  )
                                )}
                                <StyledTableCell>
                                  {vehicleGroup.vehicleIds.length}
                                </StyledTableCell>
                              </StyledTableRow>
                          );
                        }
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </Grid>
        )
      }

    }
  }

  return (
    <Grid container>
      <Grid item xs={12} md={3} style={{ display: "flex" }}>
        <div className={styles.card}>
          <div className="margin-bottom">
            <Typography variant="body1" className="opacity60 padding-bottom--small">{booking.isFleetAllocation ? '' : getLocalizedBookingSyntex(country)} {t("root:reference")}:</Typography>
            <Typography variant="body1" className="semi-bold">{booking.referenceNumber}</Typography>
          </div>
          {!website.organisation.closeGroupSharingEnabled && booking.firstInvoice?.status !== InvoiceStatus.DRAFT && showPaymentAndInvoice && (
            <>
              <div className="margin-bottom">
                <Typography variant="body1" className="opacity60 padding-bottom--small">{t("root:paymentStatus")}:</Typography>
                <Typography variant="body1" className="semi-bold">{booking.firstInvoice ? booking.firstInvoice.status : t("root:invoiceNumber")}</Typography>
              </div>
              <div className="margin-bottom">
                <Typography variant="body1" className="opacity60 padding-bottom--small">{t("root:invoiceNumber")}:</Typography>
                <Typography variant="body1" className="semi-bold">{booking.firstInvoice ? booking.firstInvoice.invoiceRef : t("root:na")}</Typography>
              </div>
            </>
          )}
          <div>
            <Typography variant="body1" className="opacity60 padding-bottom--small">{t("root:poNumber")}:</Typography>
            <Typography variant="body1" className="semi-bold">{booking.poNumber || t("root:na")}</Typography>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={5} style={{ display: "flex" }}>
        <div className={styles.card}>
          <div className="margin-bottom">
            <Typography variant="body1" className="opacity60 padding-bottom--small">{booking.isFleetAllocation ? '' : getLocalizedBookingSyntex(country)} {t("root:status")}:</Typography>
            <Typography variant="body1" className="semi-bold">{t(`root:currentBookingStatus.${BookingStatusText[booking.status]}`)}</Typography>
            {isNoShowCancellation(booking.cancellationReason) && (
              <Typography variant="body2" className="opacity60" style={{ marginTop: 4 }}>
                Cancelled - Grace Period Exceeded
              </Typography>
            )}
          </div>
          {
            booking.isSubscription &&
              booking?.deliveryAddress &&
              booking?.deliveryAddress.fullAddress ? (
              <>
                <div className="margin-bottom">
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {booking.deliveryAddress && booking.deliveryAddress.fullAddress &&
                      t("root:deliveryDetails")
                    }
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {`${booking.deliveryAddress && booking.deliveryAddress.fullAddress
                      ? booking.deliveryAddress.fullAddress
                      : t("root:na")
                      }`}
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {booking.dropoffDateTime && getLocalizedDateFormat(country, booking.pickupDateTime, DATE_TYPE.EXPANDED, booking.branch?.timeZone)}
                  </Typography>
                </div>
                <div>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {booking.deliveryAddress && booking.deliveryAddress.fullAddress &&
                      t("root:collectionDetails")
                    }
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {`${booking.deliveryAddress && booking.deliveryAddress.fullAddress
                      ? booking.deliveryAddress.fullAddress
                      : t("root:na")
                      }`}
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {booking.dropoffDateTime && getLocalizedDateFormat(country, booking.dropoffDateTime, DATE_TYPE.EXPANDED, booking.branch?.timeZone)}
                  </Typography>
                </div>
              </>
            ) : (
              <>
                <div className="margin-bottom">
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {booking.pickupOtherLocation && booking.pickupOtherLocation.fullAddress
                      ? `${t("root:deliveryAddress")}, ${t("root:dateTime")}:`
                      : `${t("root:pickUpLocation")}, ${t("root:dateTime")}:`}
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {`${booking.pickupOtherLocation && booking.pickupOtherLocation.fullAddress
                      ? booking.pickupOtherLocation.fullAddress
                      : booking.pickupServiceLocation?.name || t("root:na")
                      }`}
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {getLocalizedDateFormat(country, booking.pickupDateTime, DATE_TYPE.EXPANDED, booking.branch?.timeZone)}
                  </Typography>
                </div>
                <div>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {booking.bookingCategory === BookingType.TEST_DRIVE && booking.pickupOtherLocation?.fullAddress
                      ? `${t("root:collectionAddress")}, ${t("root:dateTime")}:`
                      : booking.dropoffOtherLocation && booking.dropoffOtherLocation.fullAddress
                        ? `${t("root:collectionAddress")}, ${t("root:dateTime")}:`
                        : `${t("root:dropOffLocation")}, ${t("root:dateTime")}:`}
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {booking.bookingCategory === BookingType.TEST_DRIVE && booking.pickupOtherLocation?.fullAddress
                      ? booking.pickupOtherLocation?.fullAddress || t("root:na")
                      : booking.dropoffOtherLocation?.fullAddress || booking.dropoffServiceLocation?.name || t("root:na")}
                  </Typography>
                  <Typography variant="body1" className="semi-bold">
                    {booking.dropoffDateTime && getLocalizedDateFormat(country, booking.dropoffDateTime, DATE_TYPE.EXPANDED, booking.branch?.timeZone)}
                  </Typography>
                </div>
              </>
            )
          }
        </div>
      </Grid>
      <Grid item xs={12} md={4} style={{ display: "flex" }}>
        <div className={styles.card} style={{ marginRight: 0 }}>
          <div className="margin-bottom">
            <Typography variant="body1" className="opacity60 padding-bottom--small">{t("root:customer")}:</Typography>
            <Typography variant="body1" className="semi-bold">
              {`${isBusinessCustomerBooking
                ? booking.businessCustomer?.businessName || ""
                : `${booking.customer?.firstName} ${booking.customer?.lastName}`
                }`}
            </Typography>
          </div>
          <div className="margin-bottom">
            <Typography variant="body1" className="opacity60 padding-bottom--small">{t("root:emailAddress")}:</Typography>
            <Typography variant="body1" className="semi-bold">
              {`${isBusinessCustomerBooking
                ? booking.businessCustomer?.billing.email
                : booking.customer
                  ? booking.customer.email
                  : ""
                }`}
            </Typography>
          </div>
          <div>
            <Typography variant="body1" className="opacity60 padding-bottom--small">{t("root:phoneNumber")}:</Typography>
            <Typography variant="body1" className="semi-bold">
              {`${isBusinessCustomerBooking
                ? booking.businessCustomer?.billing.phoneNumber.phone || ""
                : booking.customer
                  ? booking.customer.phoneNumber.phone
                  : ""
                }`}
            </Typography>
          </div>
        </div>
      </Grid>
      {(booking?.coiDetails || booking?.insurancePolicy) && <Grid item xs={12} style={{ marginTop: 10 }}>
        <div className={`${styles.box}`}>
          <div className="font-medium semi-bold margin-bottom padding-bottom">{booking?.coiDetails ? t("root:coiDetails") : t("root:insurance")}</div>
          <div style={{ margin: "0 -10px -10px -10px" }}>
            <TableContainer style={{ maxHeight: "100%", }} className={`${booking.businessCustomer ? "row-hover" : ""}`}>
              <Table stickyHeader aria-label="customized table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>{booking?.coiDetails ? t('root:policyName') : t('root:planName')}</StyledTableCell>
                    <StyledTableCell>{booking?.coiDetails?.policyNumber ? t('root:policyNumber') : t('root:description')}</StyledTableCell>
                    {
                      booking?.coiDetails?.provider &&
                      <StyledTableCell>{t("root:provider")}</StyledTableCell>
                    }
                    {
                      booking?.coiDetails?.expiryDate &&
                      <StyledTableCell>{t("root:expiryDate")}</StyledTableCell>
                    }
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell>
                      {booking?.coiDetails?.policyName ? booking?.coiDetails.policyName : booking?.insurancePolicy?.name}
                    </StyledTableCell>
                    <StyledTableCell>
                      {booking?.coiDetails?.policyNumber ? booking?.coiDetails.policyNumber : booking?.insurancePolicy?.description}
                    </StyledTableCell>
                    {booking?.coiDetails &&
                      <>
                        <StyledTableCell>
                          {booking?.coiDetails?.provider}
                        </StyledTableCell>
                        <StyledTableCell>
                          {booking?.coiDetails?.expiryDate ? getLocalizedDateFormat(country, booking?.coiDetails?.expiryDate, DATE_TYPE.CONDENSED) : t("root:na")}
                        </StyledTableCell>
                      </>
                    }
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Grid>}

      {
        renderVehicleDetails()
      }
      {
        booking.status === BookingStatus.IN_PROGRESS && booking?.activeSubscription?.swapsAllowed && (
          <Grid item xs={12} >
            <div className={styles.swapDetailsBox}>
              <Typography variant="h4">{t("root:vehicleSwapDetails")}</Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenSwapRequestDialog(true)
                  setSelectedRequestToUpdate({} as ISwapRequest)
                }}
                disabled={booking.activeSubscription.swapsAllowed === booking?.consumedSwaps?.length || booking?.swapRequests?.some(req => req.isActive)}
              >
                {(loadingCreateSwapRequest || loadingUpdateBookingSwapData) ? <CircularProgress size={"small"} /> : t("root:swapMyCar")}
              </Button>
            </div>
            <div className={`${styles.box}`} style={{ marginTop: 15 }}>
              <div style={{ margin: "0 -10px -10px -10px" }}></div>
              <TableContainer component={Paper} >
                <Table aria-label="simple table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell >{t("root:NoOfSwapsAllowed")}</StyledTableCell>
                      <StyledTableCell >{t("root:NoOfSwapsAvailed")}</StyledTableCell>
                      <StyledTableCell >{t("root:NoOfSwapsRemaining")}</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell>{booking.activeSubscription.swapsAllowed}</StyledTableCell>
                      <StyledTableCell>{booking?.consumedSwaps?.length || 0}</StyledTableCell>
                      <StyledTableCell>{booking.activeSubscription.swapsAllowed - (booking?.consumedSwaps?.length || 0)}</StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Grid>
        )
      }
      {
        booking.swapRequests && booking.swapRequests.length > 0 &&
        <Grid item xs={12} style={{ marginTop: 15 }}>
          <div className={`${styles.box}`}>
            <div className="font-medium semi-bold margin-bottom padding-bottom">{t("root:swapRequestHistory")}</div>
            <div style={{ margin: "0 -10px -10px -10px" }}></div>
            <TableContainer component={Paper} style={{ maxHeight: "100%", }} className={`${booking.businessCustomer ? "row-hover" : ""}`}>
              <Table aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell >{t("root:requestedOn").toUpperCase()}</StyledTableCell>
                    <StyledTableCell >{t("root:swapDate")}</StyledTableCell>
                    <StyledTableCell >{t("root:status").toUpperCase()}</StyledTableCell>
                    <StyledTableCell >{t("root:oldVehicle")}</StyledTableCell>
                    <StyledTableCell >{t("root:newVehicle")}</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {
                    booking.swapRequests.map((swapRequest: ISwapRequest, index: number) => {
                      return (
                        <>
                          <StyledTableRow
                            onClick={() => {
                              setOpenSwapRequestDialog(true)
                              setSelectedRequestToUpdate(swapRequest)
                            }}
                          >
                            <StyledTableCell>
                              {d.fromISO(swapRequest.createdAt).toFormat(DateTimeFormat.DEFAULT_DATE_EXPANDED)}
                            </StyledTableCell>
                            <StyledTableCell>
                              {d.fromISO(swapRequest.dateForSwap).toFormat(DateTimeFormat.DEFAULT_DATE_EXPANDED)}
                            </StyledTableCell>
                            <StyledTableCell>
                              {swapRequest.status}
                            </StyledTableCell>
                            <StyledTableCell>
                              {`${swapRequest.vehicle?.make} ${swapRequest.vehicle?.model}(${swapRequest.vehicle?.licencePlate})`}
                            </StyledTableCell>
                            <StyledTableCell >
                              {(swapRequest.status === SwapRequestStatus.APPROVED || swapRequest.status === SwapRequestStatus.COMPLETED) ? `${swapRequest.vehicleAllocated?.make} ${swapRequest.vehicleAllocated?.model} (${swapRequest.vehicleAllocated?.licencePlate})` : ""}
                            </StyledTableCell>
                          </StyledTableRow>
                        </>
                      )
                    })
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Grid>
      }
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <div className={`${styles.box}`}>
          <Grid item xs={12}>
            <DriversInformation booking={booking} />
          </Grid>
        </div>
      </Grid>
      {booking && booking.addonRequirements && booking.addonRequirements.length > 0 && <Grid item xs={12} style={{ marginTop: 10 }}>
        <div className={`${styles.box}`}>
          <div className="font-medium semi-bold margin-bottom padding-bottom">{t("root:addonsDetails")}</div>
          <div style={{ margin: "0 -10px -10px -10px" }}>
            <TableContainer style={{ maxHeight: "100%", }}>
              <Table stickyHeader aria-label="customized table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>{t("root:addOn")}</StyledTableCell>
                    <StyledTableCell>{t("root:description")}</StyledTableCell>
                    <StyledTableCell>{t("root:quantity")}</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {booking.addonRequirements.map(
                    (item, index) => {
                      return (
                        <StyledTableRow key={index}>
                          <StyledTableCell>
                            {item.displayName?.toUpperCase() ||
                              item.name?.toUpperCase()}
                          </StyledTableCell>
                          <StyledTableCell>{item.addon.description}</StyledTableCell>
                          <StyledTableCell>{item.quantity}</StyledTableCell>
                        </StyledTableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Grid>}
      {booking && booking.protectionPlan && hasValidProtectionPlan && <Grid item xs={12} style={{ marginTop: 10 }}>
        <div className={`${styles.box}`}>
          <div className="font-medium semi-bold margin-bottom padding-bottom">{t("root:protectionPlan")}</div>
          <div style={{ margin: "0 -10px -10px -10px" }}>
            <TableContainer style={{ maxHeight: "100%", }}>
              <Table stickyHeader aria-label="customized table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>{t("root:protectionPlan")}</StyledTableCell>
                    <StyledTableCell>{t("root:description")}</StyledTableCell>
                    <StyledTableCell>{t("root:quantity")}</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell>{booking?.protectionPlan.name}</StyledTableCell>
                    <StyledTableCell>{booking?.protectionPlan.plan?.description}</StyledTableCell>
                    <StyledTableCell>1</StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Grid>}
      {!website.organisation.closeGroupSharingEnabled && booking.invoices.length > 0 && <>
        <Grid item xs={12} style={{ marginTop: 10 }}>
          <div className={`${styles.box}`}>
            <div className="font-medium semi-bold margin-bottom padding-bottom">{t("root:paymentDetails")}</div>
            <div style={{ margin: "0 -10px -10px -10px" }}>
              <TableContainer style={{ maxHeight: "100%", }} className={user?.id ? "row-hover" : ""}>
                <Table stickyHeader aria-label="customized table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>{t("root:invoiceNumber")}</StyledTableCell>
                      <StyledTableCell>{t("root:invoiceType")}</StyledTableCell>
                      <StyledTableCell>{t("root:creationDate")}</StyledTableCell>
                      <StyledTableCell>{t("root:billingPeriod")}</StyledTableCell>
                      <StyledTableCell>{t("root:amount")}</StyledTableCell>
                      <StyledTableCell>{t("root:status")}</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {booking && booking.invoices && booking.invoices.map(
                      (invoice: IInvoice, index: number) => {
                        return (
                          <StyledTableRow key={index} onClick={() => user?.id && history.push(`/account/invoices/${invoice.id}`)}>
                            <StyledTableCell >
                              <span
                                style={user?.id ? {
                                  color: "rgb(24, 117, 210)",
                                  textDecoration: "none",
                                  cursor: "pointer",
                                } : {}}>{invoice.invoiceRef}</span>
                            </StyledTableCell>
                            <StyledTableCell>
                              {invoice.invoiceType === InvoiceType.SUNDRY ? InvoiceType.SUNDRY : t("root:regular").toUpperCase()}
                            </StyledTableCell>
                            <StyledTableCell>
                              {getLocalizedDateFormat(country, (invoice.confirmedAt) ? invoice.confirmedAt : invoice.dateCreated, DATE_TYPE.CONDENSED)}
                            </StyledTableCell>
                            <StyledTableCell>{`${getLocalizedDateFormat(country, invoice.startDate, DATE_TYPE.CONDENSED)}-${getLocalizedDateFormat(country, invoice.endDate, DATE_TYPE.CONDENSED)}`}</StyledTableCell>
                            <StyledTableCell>{toCurrency(invoice.totalPayableAmount, currency, locale)}</StyledTableCell>
                            <StyledTableCell>{invoice.status}</StyledTableCell>
                          </StyledTableRow>
                        );
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </Grid>
      </>
      }
      {(showDeposit || getDepositPayments().some(p => p && p.amount > 0) || getAdjustedCreditNotes().some(n => n && n.amount > 0)) && (
        <Grid item xs={12} style={{ marginTop: 10 }}>
          {showDeposit && (
          <div className={`${styles.box}`}>
              <>
                <div className="font-medium semi-bold margin-bottom padding-bottom">
                  {t("root:depositDetails")}
                </div>

                <div className="font-medium semi-bold margin-bottom">
                  <span>
                    {t("root:amount")} : {toCurrency(
                      Number(booking.depositDetails?.amount || 0),
                      currency,
                      locale
                    )}
                  </span>
                </div>
              </>     

            <div style={{ marginTop: "30px" }}>
              {getDepositPayments().some(p => p && p.amount > 0) && (
                <>
                  <div className="font-medium semi-bold margin-bottom padding-bottom">
                    {t("root:payments")}
                  </div>
                  <TableContainer style={{ maxHeight: "100%", marginBottom: 20 }}>
                    <Table stickyHeader style={{ tableLayout: "fixed", width: "100%" }}>
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell style={{ width: "20%" }}>{t("root:amount")}</StyledTableCell>
                          <StyledTableCell style={{ width: "20%" }}>{t("root:mode")}</StyledTableCell>
                          <StyledTableCell style={{ width: "20%" }}>{t("root:status")}</StyledTableCell>
                          <StyledTableCell style={{ width: "20%" }}>{t("root:date")}</StyledTableCell>
                          <StyledTableCell style={{ width: "20%" }}>{t("root:comments")}</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {getDepositPayments()
                          .filter(p => p && p.amount > 0)
                          .map((p, index) => (
                            <StyledTableRow key={p.id || index}>
                              <StyledTableCell>
                                {toCurrency(p.amount || 0, currency, locale)}
                              </StyledTableCell>
                              <StyledTableCell>
                                {`${p.paymentMode}${p.paymentGateway ? ` (${PaymentGatewayLabels[p.paymentGateway]})` : ""}`}
                              </StyledTableCell>
                              <StyledTableCell>
                                {p.status}
                              </StyledTableCell>
                              <StyledTableCell>
                                {getLocalizedDateFormat(country, p.dateCreated || "", DATE_TYPE.CONDENSED)}
                              </StyledTableCell>
                              <StyledTableCell>
                                {p.expireBy
                                  ? `Expires on ${getLocalizedDateFormat(country, p.expireBy, DATE_TYPE.CONDENSED)}`
                                  : ""}
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
              
              {getAdjustedCreditNotes().some(n => n && n.amount > 0) && (
                <>
                  <div className="font-medium semi-bold margin-bottom padding-bottom">
                    {"Credit Notes Applied to Deposit"}
                  </div>

                  <TableContainer style={{ maxHeight: "100%" }}>
                    <Table stickyHeader style={{ tableLayout: "fixed", width: "100%" }}>
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell style={{ width: "20%" }}>{t("root:amount")}</StyledTableCell>
                          <StyledTableCell style={{ width: "20%" }}>{t("root:reference")}</StyledTableCell>
                          <StyledTableCell style={{ width: "60%" }}>{t("root:date")}</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>

                      <TableBody>
                        {getAdjustedCreditNotes()
                          .filter(n => n && n.amount > 0)
                          .map((n, index) => (
                            <StyledTableRow key={n.creditNote?.id || index}>
                              <StyledTableCell>
                                {toCurrency(n.amount || 0, currency, locale)}
                              </StyledTableCell>
                              <StyledTableCell>
                                {n.creditNote?.creditNoteRef || "-"}
                              </StyledTableCell>
                              <StyledTableCell>
                                {getLocalizedDateFormat(country, n.adjustedAt || "", DATE_TYPE.CONDENSED)}
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </div>
          </div>
          )}
        </Grid>
      )}

      {getTaskDetails()?.jobId && shouldShowTrackingModal() && (
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <MapSection jobId={getTaskDetails()?.jobId} lastKnownDriverLocation={getTaskDetails()?.lastKnownDriverLocation} customerLocation={getTaskDetails()?.customerLocation} />
        </Grid>
      )}
      {openSwapRequestDialog && (
        <GenerateSwapRequestDialog
          open={openSwapRequestDialog}
          onClose={() => setOpenSwapRequestDialog(false)}
          onCreateSwapRequest={onCreateSwapRequest}
          activeSubscription={booking.activeSubscription}
          swapRequest={selectedRequestToUpdate}
          cancelSwapRequest={onCancelSwapRequest}
          loadingCancelSwap={loadingCancelSwap}
          loadingUpdateBookingSwapData={loadingUpdateBookingSwapData}
          loadingCreateSwapRequest={loadingCreateSwapRequest}
          booking={booking}
        />
      )}

    </Grid>
  )
}

export default BookingSummary